import { LoaderFunction, useLoaderData } from "react-router-dom";
import { redeemCode } from "../../../common/api/decimal/methods/redeem.ts";

export const redeemLoader: LoaderFunction = ({ params }) => {
  return redeemCode(params.code!);
};

export function useRedeemLoaderData() {
  return useLoaderData<Awaited<ReturnType<typeof redeemCode>>>();
}
